import { camelCase } from "lodash";
import { is, map, toPairs, fromPairs, pipe } from "ramda";

export const titleCaseToCamelCase = input => {
  if (is(Array, input)) {
    return map(titleCaseToCamelCase, input);
  }

  if (is(Object, input)) {
    return pipe(
      toPairs,
      map(([key, value]) => [camelCase(key), titleCaseToCamelCase(value)]),
      fromPairs
    )(input);
  }

  return input;
};
